import TopBanner from "@components/emeraldCity/TopBanner";
import GangstaverseLand from "@components/home/GangstaverseLand.component";
import EmeraldCityInfo from "@components/emeraldCity/EmeraldCityInfo.component";
import CrownToken from "@components/emeraldCity/CrownToken.component";
import Product from "@components/product/Product.component";
import Carousel from "@components/home/Carousel.component";
import { useEffect } from 'react';

const EmeraldCity = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);
  return (
    <>
      <TopBanner />
      <EmeraldCityInfo />
      <GangstaverseLand />
      <CrownToken />
      <Carousel />
      <Product />
    </>
  );
};

export default EmeraldCity;
